export interface SpinnerProps {
  size?: number;
}

export function Spinner({ size = 20 }: SpinnerProps) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        border: "2.5px solid var(--color-border)",
        borderTopColor: "var(--color-primary)",
        animation: "salesapp-spin 0.7s linear infinite",
      }}
    >
      <style>{`@keyframes salesapp-spin { to { transform: rotate(360deg); } }`}</style>
    </span>
  );
}
